import React from "react";

export const ShippingReturns = () => {
  return (
    <div className="min-h-screen pt-20 bg-white">
      {/* Main Content */}
      <section className="py-32 md:py-40 px-6">
        <div className="max-w-3xl mx-auto text-center">
          {/* Heading */}
          <h1 
            className="text-4xl md:text-5xl mb-20 font-light tracking-wide" 
            style={{ fontFamily: "'Playfair Display', serif", fontWeight: 300 }}
          >
            Shipping & Returns
          </h1>

          {/* Body Content */}
          <div className="space-y-16 text-left">
            {/* Shipping Section */}
            <div className="space-y-8">
              <h2 
                className="text-2xl md:text-3xl font-light tracking-wide text-center" 
                style={{ fontFamily: "'Playfair Display', serif", fontWeight: 300 }}
              >
                Shipping
              </h2>
              
              <div className="space-y-6">
                <p 
                  className="text-base md:text-lg leading-loose text-[#2C2C2C] font-light"
                  style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                >
                  Local delivery across all Nigerian states.
                </p>

                <p 
                  className="text-base md:text-lg leading-loose text-[#2C2C2C] font-light"
                  style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                >
                  International shipping available to UK, USA, and Canada.
                </p>

                <p 
                  className="text-base md:text-lg leading-loose text-[#2C2C2C] font-light"
                  style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                >
                  Orders processed within 5–10 business days.
                </p>

                <p 
                  className="text-base md:text-lg leading-loose text-[#2C2C2C] font-light"
                  style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                >
                  International orders may be subject to customs duties and taxes, which are the responsibility of the customer.
                </p>
              </div>
            </div>

            {/* Returns & Exchanges Section */}
            <div className="space-y-8 pt-12">
              <h2 
                className="text-2xl md:text-3xl font-light tracking-wide text-center" 
                style={{ fontFamily: "'Playfair Display', serif", fontWeight: 300 }}
              >
                Returns & Exchanges
              </h2>
              
              <div className="space-y-6">
                <p 
                  className="text-base md:text-lg leading-loose text-[#2C2C2C] font-light"
                  style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                >
                  Exchanges accepted within 7 days of delivery.
                </p>

                <p 
                  className="text-xs text-[#A39383] font-light leading-relaxed"
                  style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                >
                  Exchanges are subject to product availability at the time of request.
                </p>

                <p 
                  className="text-base md:text-lg leading-loose text-[#2C2C2C] font-light"
                  style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                >
                  Items must be unworn and in original condition.
                </p>

                <p 
                  className="text-base md:text-lg leading-loose text-[#2C2C2C] font-light"
                  style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                >
                  Returns accepted for sizing issues only.
                </p>

                <p 
                  className="text-base md:text-lg leading-loose text-[#2C2C2C] font-light"
                  style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                >
                  Customer responsible for return shipping unless item is defective.
                </p>

                <p 
                  className="text-base md:text-lg leading-loose text-[#2C2C2C] font-light"
                  style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                >
                  No refunds on custom or made-to-order pieces.
                </p>
              </div>
            </div>

            {/* Contact Note */}
            <div className="pt-16 text-center">
              <p 
                className="text-sm text-[#A39383] font-light leading-relaxed"
                style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
              >
                For inquiries regarding your order, please contact us directly.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
